<template>
  <router-view></router-view>
</template>

<script setup name="App">
import { onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router'
const router = useRouter()
const route = useRoute()
const isMobile = () => {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return flag;
}
 
onMounted(() => {
  if (route.path === '/' || route.path === '/mobile_index') {
    if (isMobile()) {
      (function (doc, win) {
        var docEl = doc.documentElement
        var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
        var recalc = function () {
          var clientWidth = docEl.clientWidth
          if (!clientWidth) return
          docEl.style.fontSize = (clientWidth / 3.9) + 'px'
        }
      
        if (!doc.addEventListener) return
        win.addEventListener(resizeEvt, recalc, false)
        doc.addEventListener('DOMContentLoaded', recalc, false)
      })(document, window)
      router.replace('/mobileIndex')
    } else {
      router.replace('/')
    }
  }
})
</script>
<style lang="less">
body{
  margin: 0;
}
</style>